import axios from 'axios'

export default {
	namespaced: true,

	state: {
    retailZones: []
	},

	getters: {
    retailZones: state => state.retailZones,
    filteredRetailZones: state => filter => {
      let filtered = [...state.retailZones]

      if (!Object.keys(filter).length)
        return state.retailZones

      if (filter.buildings && filter.buildings.length)
        filtered = filtered.filter(item => filter.buildings.includes(item.building.building_name))

      if (filter.floors && filter.floors.length)
        filtered = filtered.filter(item => filter.floors.includes(item.building.floor_number))

      if (Number.isInteger(Number(filter.availability))) {
        filtered = filtered.filter(item => String(filter.availability) === item.flat_status)
      }

      if (filter.priceVat) {
        filtered = filtered.filter(item => {
          const price = Number(item.flat_price)
          return price >= filter.priceVat[0] && price <= filter.priceVat[1]
        })
      }

      if (filter.totalArea) {
        filtered = filtered.filter(item => {
          const totalArea = Number(item.flat_area)
          return totalArea >= filter.totalArea[0] && totalArea <= filter.totalArea[1]
        })
      }

      return filtered
    }
	},

	mutations: {
		retrievedRetailZones(state, retailZones) {
      state.retailZones = retailZones
    }
	},

	actions: {
		async loadRetailZones({ commit, state }) {
			try {
        if(state.retailZones.length)
          return

				const resp = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/retail-zones`)
				commit('retrievedRetailZones', resp.data.data)
			} catch(err) { console.error(err) }
		}
	}

}
